import React, { useEffect, useState } from 'react'
import { Spin } from 'antd'
import { connect } from 'react-redux'
import { useForm } from 'react-hook-form'
import { Prompt } from 'react-router-dom';
import { ApiSpin, FilledButton, FilledBrightButton } from '@oneblinktech-org/helios-base'
import { debouncedGetProfile, debouncedUpdateProfile } from '../../store/user/actions'
import { getCookie, openNotification, ROLES, SUPPORT_URL } from '../../helpers/globals';
import MyShopInformation from '../../components/user/myShopInformation';
import Block from '../../components/common/block';
import ExpandableTable from '../../components/tables/expandableTable';
import { addUserInOrg, getOrgUsers } from '../../services/user';
import { initializePusher, unbindPusher } from '../../pusherManager';
import { save } from '../../fakeData/svgFiles.js'
import Loader from '../../components/Loader.js';

function Settings(props) {
    const { register, handleSubmit, getValues, setValue, reset, watch, control, trigger, formState: { errors, dirtyFields } } = useForm()
    const orgId = getCookie('active_organization_id')

    const [saveLoading, setLoading] = useState(false)
    const [isError, setISError] = useState(false)
    const [errorMsg, setErrorMsg] = useState("")
    const [isSuccess, setIsSuccess] = useState(false)
    const [statusColumns, setStatusColumns] = useState({})
    const [organization, SetOrganization] = useState({})
    const [userFToogle, setUserFToogle] = useState(false)
    const [usersInOrg, SetUsersInOrg] = useState([])
    const [loading, setLoadingData] = useState(false)
    const [usersToggle, setUsersToggle] = useState(localStorage.getItem('usersToggle') ? JSON.parse(localStorage.getItem('usersToggle')) === true : true)
    const [saveSuccessTXT, setSaveSuccessTXT] = useState("")
    const [newUser, setNewUser] = useState({
        name: "",
        email: "",
        is_active: true
    })

    const columns = [
        {
            name: 'Name',
            fixed: 'left',
            align: 'left',
            sorter: false,
            cell: record =>
                <a className={(!record.is_active ? "inactive" : "") + " table_anchor d-flex flex-row justify-content-start align-items-center"}>
                    <div className="profile-user-avatar">
                        {
                            (typeof record?.helios_user_setting?.avatar !== 'undefined' && record?.helios_user_setting?.avatar != null) ?
                                <img alt="" src={record?.helios_user_setting?.avatar} />
                                :
                                <img alt="" src={require('../../assets/images/skel-user.png').default} />
                        }
                        <div style={{
                            backgroundColor: record.is_active ? 'rgba(95, 221, 151, 1)' : 'rgba(244, 99, 99, 1)'
                        }} className="mark-green" />
                    </div>
                    {
                        record.firstname + ' ' + record.lastname
                    }
                </a>,
        },
        {
            name: 'E-mail',
            align: 'left',
            sorter: false,
            cell: record => <span className={(!record.is_active ? "inactive" : "")}>{record.email}</span>,
        },
        {
            name: 'Role',
            align: 'left',
            sorter: false,
            cell: record => <span className={(!record.is_active ? "inactive" : "")}>{record.userType && record.userType.name}</span>,
        },
        {
            name: 'Status',
            align: 'left',
            cell: record =>
                <div
                    className={(!record.is_active ? "inactive" : "") + " job_status"}
                    style={{ backgroundColor: record.is_active ? 'rgba(95, 221, 151, 1)' : 'rgba(244, 99, 99, 1)' }}>
                </div>,
        }
    ]

    useEffect(() => {
        initializePusher("organizations", "choose-event", (data) => {
            if (data?.orgId?.toString() === orgId?.toString()) {
                props.debouncedGetProfile();
                callOrgUsers();
            }
            if (data.event === "selected" && data?.orgId) {
                props.debouncedGetProfile();
                callOrgUsers();
            }
        })

        return () => {
            unbindPusher("organizations", "choose-event")
        }
    }, [orgId, props])

    useEffect(() => {
        callOrgUsers()
    }, [])

    useEffect(() => {
        let isMounted = true
        if (isMounted && Object.keys(props.user.data).length > 0) {
            if (Object.keys(props.user.data).length > 0) {
                if ((props.user.data.organizations).length > 0) {
                    SetOrganization(props.user.data.organizations[0])
                }

                reset({
                    email: props?.user?.data?.email ?? "",
                    shopName: props?.user?.data?.organizations?.[0]?.['name'] ?? "",
                    shopAddr: props?.user?.data?.organizations?.[0]?.['address'] ?? "",
                    shopState: props?.user?.data?.organizations?.[0]?.['state'] ?? "",
                    shopZip: props?.user?.data?.organizations?.[0]?.['zipcode'] ?? "",
                    shopCity: props?.user?.data?.organizations?.[0]?.['city'] ?? "",
                    shopPhone: props?.user?.data?.organizations?.[0]?.['phone'] ?? "",
                })
            }
        } else {
            props.debouncedGetProfile();
        }
        return () => {
            isMounted = false
        }
    }, [props.user.data])

    useEffect(() => {
        setIsSuccess(props.user.isSuccess)
        setISError(props.user.isSuccess === false)
        setErrorMsg(props.user.erros)
    }, [props.user.isUpdating])

    const callOrgUsers = async () => {
        await setLoadingData(true)
        await getOrgUsers().then(response => {
            SetUsersInOrg(response.data)
            setLoadingData(false)
        }).catch(error => {
            console.log(error)
            setLoadingData(false)
        });
    }

    const onSetCards = (cards, cardOrder) => {
        setStatusColumns({
            'cards': cards,
            'cardOrder': cardOrder
        })
    }

    const addNewUserInOrg = async () => {
        if (newUser.name === "" || newUser.e === "") {
            return;
        }

        if (usersInOrg.some(item => item.email === newUser.email) || newUser.email === getValues('email')) {
            openNotification('Alert!', 'This user already has access.')
            return;
        }

        const nameParts = newUser.name.trim().split(" ");
        let firstname = nameParts[0];
        let lastname = "";

        if (nameParts.length > 1) {
            lastname = nameParts.slice(1).join(" ");
        }

        let newUserForm = {
            ...newUser,
            firstname: firstname,
            lastname: lastname,
            is_active: newUser.is_active ? 1 : 0,
            role_id: ROLES.Subordinate
        }

        await setLoading(true)
        await addUserInOrg(newUserForm).then(res => {
            setIsSuccess(true)
            if (res.data && res.status === 200) {
                getOrgUsers()
                    .then(async response => {
                        await SetUsersInOrg(response.data)
                        await setUserFToogle(false)
                        await setLoading(false)
                    }).catch(() => {
                        setUserFToogle(false)
                        setLoading(false)
                    });
            }
        }).catch(error => {
            setISError(true)
            setErrorMsg(error?.message ? error?.message : 'Something went wrong, please try again later or contact support.')
            console.log(error)
            setLoading(false)
        })
        await setNewUser({
            name: "",
            email: "",
            is_active: true
        })
    }

    const editProfile = (data) => {
        let form = new FormData()
        form.append('email', data.email)
        form.append('statusColumns', JSON.stringify(statusColumns))
        form.append('shopName', data.shopName)
        form.append('shopPhone', data.shopPhone)
        form.append('shopState', data.shopState)
        form.append('shopAddr', data.shopAddr)
        form.append('shopCity', data.shopCity)
        form.append('shopZip', data.shopZip)
        props.debouncedUpdateProfile({ form: form })
    }

    const resetData = () => {
        if (Object.keys(dirtyFields).length > 0 && window.confirm("Changed you made may not be saved.")) {
            reset({
                email: props.user.data.email ?? "",
                shopName: props?.user?.data?.organizations?.[0]?.['name'] ?? "",
                shopAddr: props?.user?.data?.organizations?.[0]?.['address'] ?? "",
                shopState: props?.user?.data?.organizations?.[0]?.['state'] ?? "",
                shopZip: props?.user?.data?.organizations?.[0]?.['zipcode'] ?? "",
                shopCity: props?.user?.data?.organizations?.[0]?.['city'] ?? "",
                shopPhone: props?.user?.data?.organizations?.[0]?.['phone'] ?? "",
            })
        }
    }

    window.onbeforeunload = function (e) {
        if (Object.keys(dirtyFields).length > 0) {
            return "Do you want to exit this page?";
        }
    }

    return (
        <>
            <Loader loading={props.user.loading} />
            <Spin spinning={props.user.loading}>
                <Prompt
                    when={Object.keys(dirtyFields).length > 0}
                    message="You have unsaved changes, are you sure you want to leave?"
                />
                <ApiSpin loading={saveLoading || props.user.isUpdating} error={isError} success={isSuccess} error_txt={errorMsg} support_url={SUPPORT_URL} />
                <form onSubmit={handleSubmit(editProfile)} autoComplete="off">
                    <div className='d-flex flex-column user-edit'>
                        <div className='header pb-3'>
                            <h6 className='title'>Settings</h6>
                            <div className='action'>
                                {
                                    Object.keys(dirtyFields).length > 0
                                        ? <span className='text-danger mr-3'>You have unsaved changes</span>
                                        : saveSuccessTXT != "" &&
                                        <span className='text-success mr-3 '>{saveSuccessTXT}</span>
                                }
                                {Object.keys(dirtyFields).length > 0 &&
                                    <FilledButton
                                        title='Cancel'
                                        clickEvent={(e) => resetData()}
                                    />
                                }
                                <FilledBrightButton
                                    svgFile={save}
                                    title='Save'
                                    type="submit"
                                    clickEvent={(e) => { }}
                                    disabled={Object.keys(dirtyFields).length === 0}
                                />
                            </div>
                        </div>
                        <div className='full-height d-flex flex-column justify-content-start align-items-center'>
                            <MyShopInformation
                                data={organization}
                                register={register}
                                reset={reset}
                                handleSubmit={handleSubmit}
                                getValues={getValues}
                                setValue={setValue}
                                control={control}
                                errors={errors}
                                dirtyFields={dirtyFields}
                                watch={watch}
                                sendCards={(cards, cardOrder) => onSetCards(cards, cardOrder)}
                                trigger={trigger}
                            />

                            <div className='w-100 mt-2 profile-body py-3 px-3 pl-30'>
                                <Block
                                    title='Users'
                                    isOpen={usersToggle}
                                    onToggle={() => {
                                        let usersToggleV = !usersToggle
                                        localStorage.setItem('usersToggle', usersToggleV)
                                        setUsersToggle(usersToggleV)
                                    }}
                                >
                                    <div className="">
                                        <ExpandableTable
                                            columns={columns}
                                            data={usersInOrg}
                                            toggleTxt="Inactive"
                                            getData={(offset) => { }}
                                            deleteRecord={(id) => { }}
                                            route="/#"
                                            refreshTable={() => { }}
                                            searchPlaceholder="Search user name, e-mail ..."
                                            isExpert={false}
                                            userFToogle={userFToogle}
                                            setUserFToogle={setUserFToogle}
                                            newUser={newUser}
                                            setNewUser={setNewUser}
                                            addNewUserInOrg={addNewUserInOrg}
                                            saveLoading={saveLoading}
                                            loadingData={loading}
                                        />

                                    </div>
                                </Block>
                            </div>
                        </div>
                    </div>
                </form>
            </Spin>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.UserReducer.user,
        types: state.UserReducer.user_types.data
    }
}

const mapDispachToProps = (dispatch) => ({
    debouncedGetProfile: () => debouncedGetProfile(dispatch),
    debouncedUpdateProfile: (data) => debouncedUpdateProfile(dispatch, data),
})

export default connect(mapStateToProps, mapDispachToProps)(Settings)